export const REQUIRED_DOCUMENTS = {
  idOrPassport: "ID / Passport",
  proofOfFunding: "Proof of Funding",
  nextOfKinID: "Next of Kin ID",
  proofOfResidence: "Proof of Residence",
};
